module.exports = __webpack_public_path__ + "img/form@2x.fffff342.png";